export class SpecializationModel {
  public name: string;
  public parentGroup: string;
  public position: PositionModel;
  public level1: boolean;
  public level2: boolean;
  public mainGroup;
  public beginnerLevels: Array<BeginnerLevelModel>;
  public advancedLevels: Array<AdvancedLevelModel>;

  constructor(name: string,
              parentGroup: string,
              position: PositionModel,
              level1: boolean,
              level2: boolean,
              beginnerLevels: Array<BeginnerLevelModel>,
              advancedLevels: Array<AdvancedLevelModel>
  ) {
    this.name = name;
    this.parentGroup = parentGroup;
    this.position = position;
    this.level1 = level1;
    this.level2 = level2;
    this.beginnerLevels = beginnerLevels;
    this.advancedLevels = advancedLevels;
  }
}

export class BeginnerLevelModel {
  public id: string;
  public ruPpt: string;
  public enPpt: string;
  public queueNumber: number;
  public enYoutubeLink: string;
  public ruYoutubeLink: string;
  public enRequirements: string;
  public ruRequirements: string;
  public ruQuestions: Array<QuestionSpecializationModel>;
  public enQuestions: Array<QuestionSpecializationModel>;


  constructor(id: string,
              ruPpt: string,
              enPpt: string,
              queueNumber: number,
              enYoutubeLink: string,
              ruYoutubeLink: string,
              enRequirements: string,
              ruRequirements: string,
              ruQuestions: Array<QuestionSpecializationModel>,
              enQuestions: Array<QuestionSpecializationModel>
  ) {
    this.id = id;
    this.ruPpt = ruPpt;
    this.enPpt = enPpt;
    this.queueNumber = queueNumber;
    this.enYoutubeLink = enYoutubeLink;
    this.ruYoutubeLink = ruYoutubeLink;
    this.enRequirements = enRequirements;
    this.ruRequirements = ruRequirements;
    this.ruQuestions = ruQuestions;
    this.enQuestions = enQuestions;
  }
}

export class AdvancedLevelModel {
  public id: string;
  public queueNumber: number;
  public enRequirements: string;
  public ruRequirements: string;

  constructor(id: string,
              queueNumber: number,
              enRequirements: string,
              ruRequirements: string) {
    this.id = id;
    this.queueNumber = queueNumber;
    this.enRequirements = enRequirements;
    this.ruRequirements = ruRequirements;
  }
}

export class QuestionSpecializationModel {
  public questionText: string;
  public rightAnswer: AnswerModel;
  public answers: Array<AnswerModel>;

  constructor(questionText: string, rightAnswer: AnswerModel, answers: Array<AnswerModel>) {
    this.questionText = questionText;
    this.rightAnswer = rightAnswer;
    this.answers = answers;
  }
}

export class AnswerModel {
  public answerText: string;
}

export class PositionModel {
  public id: number;
  public name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}









// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/specializations/models/learning.model.ts